import React from 'react';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Table from '../../../Common/Table/Table/Table';
import useApiData from '../../../../../hooks/useApiData';
import Loading from '../../../Common/Loading/Loading';
import APIClient from '../../../../../util/APIClient';
import { getErrorComponentFromHttpError } from '../../../Common/Error/Error';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import useAuth from '../../../../../hooks/useAuth';

export default function OrganisationNonContributors() {
  const navigate = useNavigate();
  const { groups } = useAuth();
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const { data, error, isLoading, reload } = useApiData({
    path: `/administrator/users`,
    params: {
      group: 'organisationNonContributors',
    },
  });

  const disableUsers = React.useCallback(async () => {
    await APIClient.patch('/administrator/users', {
      cognitoIds: selectedUsers,
      operation: 'disable',
    });
    reload();
  }, [selectedUsers]);

  const enableUsers = React.useCallback(async () => {
    await APIClient.patch('/administrator/users', {
      cognitoIds: selectedUsers,
      operation: 'enable',
    });
    reload();
  }, [selectedUsers]);

  if (isLoading) {
    return <Loading message="Fetching organisation non-contributors..." />;
  }

  if (error || data === null) {
    return getErrorComponentFromHttpError(error);
  }

  return (
    <Table
      rows={data}
      linkFunction={(id) => `/administrator/users/${id}`}
      topButtons={
        groups.includes('administrators')
          ? [
              {
                label: 'Invite User',
                variant: 'contained',
                startIcon: <PersonAddIcon />,
                to: '/administrator/users/invite',
              },
            ]
          : undefined
      }
      allowSelect={groups.includes('administrators')}
      onSelected={groups.includes('administrators') ? (selected) => setSelectedUsers(selected) : undefined}
      selectedActions={
        groups.includes('administrators')
          ? [
              {
                handler: enableUsers,
                label: 'Enable users',
                icon: <LockOpenIcon />,
              },
              {
                handler: disableUsers,
                label: 'Disable users',
                icon: <LockIcon />,
              },
            ]
          : undefined
      }
      keyColumn="cognitoId"
      title="Organisation Non-Contributors"
      columns={[
        {
          id: 'firstName',
          label: 'First name',
          numeric: false,
        },
        {
          id: 'lastName',
          label: 'Last name',
          numeric: false,
        },
        {
          id: 'email',
          label: 'E-mail address',
          numeric: false,
        },
        {
          id: 'isEnabled',
          label: 'Enabled',
          boolean: true,
        },
      ]}
    />
  );
}
